import { Component } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { IonicPage, NavController, NavParams, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the CalendarPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

//@IonicPage()
@Component({
  selector: 'page-calendar',
  templateUrl: 'calendar.html',
})
export class CalendarPage {
  meetings = [];
  accessCode = "";
  authtoken = "";
  userMail = "";
  isEmpty = false;

  constructor(
      public navCtrl: NavController, 
      public loadingCtrl: LoadingController,
      public navParams: NavParams,   
      public http: HttpClient,  
      private storage: Storage,  
      public global: GlobalProvider,
      public toastCtrl: ToastController
    ) {

      this.storage.get('accesscode').then((val) => {
        this.accessCode = val;
        this.storage.get('Authorization').then((val1) => {
          this.authtoken = val1;
          this.storage.get('usermail').then((val) => {
            this.userMail = val;
            this.getMeetingList()
          });
        });
        
      });
  }

  

  ionViewDidLoad() {
    console.log('ionViewDidLoad CalendarPage');
    
  }

  goback(){
    this.navCtrl.pop();
  }

  getMeetingList(){
    
    this.global.loading.present();

    setTimeout(() => {
      //console.log('hhh');
    }, 5000);
    

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization':this.authtoken
      })
    };
  
    this.http.get(this.global.baseUrl+"api/meeting/"+this.userMail, httpOptions)//requestOpt)
      .subscribe((data:any) => {
        
        if(data.error == true){
          let toast = this.toastCtrl.create({
            message: 'Error!.',//data.errorList[0].description,
            duration: 5000,
            position: 'bottom',
            showCloseButton:true,
            closeButtonText:'Close'
          });

          toast.onDidDismiss(() => {
            console.log('Dismissed toast');
          });
        
          toast.present();
          this.global.loading.dismiss();
        }else{
          console.log(data.meetingDTO.length);
          if(data.meetingDTO.length > 0){
            this.isEmpty = false;
            this.meetings.push(data.meetingDTO);
          }else{
            this.isEmpty = true;
          }
          this.global.loading.dismiss();
          
        }
      }, error => {
        console.log(error);
        this.isEmpty = true;
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 5000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();
        this.global.loading.dismiss();
        
      });
  }
  


}



// WEBPACK FOOTER //
// ./src/pages/calendar/calendar.ts